import React from 'react'
import { Grid } from '@mui/material'
import Footer from './footer'

const AuthLayout = ({ children }) => {
  return (
    <Grid container flexDirection='column' minHeight='100vh'>
      <Grid item flex={1}>
        {children}
      </Grid>
      <Footer />
    </Grid>
  )
}

export default AuthLayout
